export default __webpack_public_path__ + "static/media/tuna.56dbc048.png";